import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "account-ratio-ribbon__legend" }
const _hoisted_2 = { class: "account-ratio-ribbon__legend-message" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import type { AccountRatioStatus } from '@exchange/libs/futures/service/src/lib/account-ratio';


export default /*#__PURE__*/_defineComponent({
  __name: 'AccountRatioRibbon',
  props: {
  status: { type: Object as PropType<AccountRatioStatus>, required: true },
},
  setup(__props) {

const { t, te } = useI18n({ useScope: 'global' });

const props = __props;

const title = computed(() => t(`modules.ribbons.accountRatio.${props.status}.title`));
const text = computed(() => (te(`modules.ribbons.accountRatio.${props.status}.text`) ? t(`modules.ribbons.accountRatio.${props.status}.text`) : ''));

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["account-ratio-ribbon", `account-ratio-ribbon--${__props.status.toLowerCase()}`])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("strong", null, _toDisplayString(title.value), 1),
        _createTextVNode(" " + _toDisplayString(text.value), 1)
      ])
    ])
  ], 2))
}
}

})